import { BlocksEditor } from "components/promotions/BlocksEditor/BlocksEditor"

import { getLanguageName } from "constants/languages"

import { PromotionBlock } from "services/promotions/type"

import { DescriptionEditor } from "./DescriptionEditor"
import { TranslationForm } from "./types"

type Props = {
  activeLocale: string
  tr: TranslationForm

  onTitleChange: (v: string) => void
  onShortTitleChange: (v: string) => void
  onDescriptionChange: (html: string) => void
  onBannerChange: (file: File) => void
  onThumbnailChange: (file: File) => void
  onBlocksChange: (blocks: PromotionBlock[]) => void
}

export const PromotionTranslationFields = ({
  activeLocale,
  tr,
  onTitleChange,
  onShortTitleChange,
  onDescriptionChange,
  onThumbnailChange,
  onBannerChange,
  onBlocksChange
}: Props) => {
  return (
    <>
      <div className="flex flex-col gap-4 border border-dashed border-[rgba(132,_0,_168,_0.8)] rounded-lg p-2">
        <div className="text-2xl">Translatable fields</div>
        <div>
          <label className="label block mb-1">
            Title * <span className="text-gray-500">({getLanguageName(activeLocale)})</span>
          </label>
          <input className="input input-bordered w-full" value={tr.title} onChange={(e) => onTitleChange(e.target.value)} />
        </div>

        <div>
          <label className="label block mb-1">
            Short Title <span className="text-gray-500">({getLanguageName(activeLocale)})</span>
          </label>
          <input
            className="input input-bordered w-full"
            value={tr.short_title ?? ""}
            onChange={(e) => onShortTitleChange(e.target.value)}
          />
        </div>

        <div>
          <label className="label block mb-1">
            Banner Image <span className="text-gray-500">({getLanguageName(activeLocale)})</span>
          </label>

          {typeof tr.banner_image === "string" && tr.banner_image && (
            <p className="text-xs text-gray-400 break-all mb-1">Current: {tr.banner_image}</p>
          )}
          {tr.banner_image instanceof File && <p className="text-md text-emerald-400 break-all mb-1">Selected: {tr.banner_image.name}</p>}

          <input
            type="file"
            accept="image/*"
            className="file-input file-input-bordered w-full"
            onChange={(e) => {
              const f = e.target.files?.[0]
              if (f) onBannerChange(f)
            }}
          />

          <p className="text-xs text-gray-400 mt-1">Leave empty to keep current image.</p>
        </div>

        <div>
          <label className="label block mb-1">
            Thumbnail Image <span className="text-gray-500">({getLanguageName(activeLocale)})</span>
          </label>

          {typeof tr.thumbnail_image === "string" && tr.thumbnail_image && (
            <p className="text-xs text-gray-400 break-all mb-1">Current: {tr.thumbnail_image}</p>
          )}
          {tr.thumbnail_image instanceof File && (
            <p className="text-md text-emerald-400 break-all mb-1">Selected: {tr.thumbnail_image.name}</p>
          )}

          <input
            type="file"
            accept="image/*"
            className="file-input file-input-bordered w-full"
            onChange={(e) => {
              const f = e.target.files?.[0]
              if (f) onThumbnailChange(f)
            }}
          />

          <p className="text-xs text-gray-400 mt-1">Leave empty to keep current image.</p>
        </div>

        <DescriptionEditor locale={activeLocale} value={tr.description ?? ""} onChange={onDescriptionChange} />

        <BlocksEditor value={tr.blocks ?? []} onChange={onBlocksChange} />
      </div>
    </>
  )
}
